import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { createQueryData } from '../helpers/createQueryData';

const endPoint = 'Acceptance/check_record_availability_by_address_id';

const { useQuery, createKey, fn } = createQueryData({
  endPoint,
  options: {
    errorMessage:
      'Не удалось проверить возможность записи на выбранное помещение',
  },
});

export const useCheckRegisterAvailabilityQuery = ({
  params: { addressId } = {},
  options,
} = {}) =>
  useQuery({
    params: { addressId },
    options: { enabled: Boolean(addressId), staleTime: 0, ...options },
  });

export const useCheckRegisterAvailabilityFetch = () => {
  const queryClient = useQueryClient();

  return useCallback(
    ({ addressId }) => {
      const params = { addressId };
      return queryClient.fetchQuery(createKey(params), () => fn(params));
    },
    [queryClient]
  );
};

export const checkRegisterAvailabilityFetch = ({
  queryClient,
  params: { addressId },
  options,
}) =>
  queryClient.fetchQuery(
    createKey({ addressId }),
    () => fn({ addressId }),
    options
  );
